
import useParticipantSourceDataEventStatuses from "@/hooks/data/useParticipantSourceDataEventStatuses";
import { createContext } from "react";

export interface IParticipantSourceDataEventStatusesContext extends ReturnType<typeof useParticipantSourceDataEventStatuses> {
}

export const ParticipantSourceDataEventStatusesContext = createContext<IParticipantSourceDataEventStatusesContext>({
    data: undefined,
    idMap: {},
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default ParticipantSourceDataEventStatusesContext;